import "./TermsOfService.module.css";
import Header from "@/reusable_sections/Header";
import TermsOverview from "./sections/TermsOverview";
import DetailedClauses from "./sections/DetailedClauses";
import AcquisitionInquiry from "./sections/AcquisitionInquiry";
import Footer from "@/reusable_sections/Footer";
export default function TermsOfServicePage() {
  return <div>
      <Header />
      <TermsOverview />
      <DetailedClauses />
      <AcquisitionInquiry />
      <Footer />
    </div>;
}